import Request from '../lib/Request';
import { GetPresignedUrl } from './contracts/Upload.contract';

export async function getPresignedUrl(filename: string, type: string): Promise<GetPresignedUrl.Response> {
    return Request.post('/upload_file/get_presigned_url', { filename, type});
};
